export default {
  read: {
    title: "Get in touch with your advisor",
    availability:
      "You can request a consultation with one of our experts to help with anything. The number of appointments depends on the plan you have (basic or premium) if you need more appointments you can always switch to premium and you will have 2 extra appointments per month.",
    premium:
      "We recommend that you take advantage of these appointments to improve your experience with us, but yes… don't waste them! When you have booked and cannot attend, cancel the appointment with at least 24 hours, otherwise you will lose one of your consultancies for that month."
  }
};
